import usingServiceAdvantage from './usingDimSumPOS';
import frequentlyAskedQuestions from './dimsum-frequentlyAskedQuestions';
const SectionContent = {
  topSection: {
    en: {
      title: 'POS for Dim Sum',
      description: `Chowbus is the industry’s top POS for Dim Sum Restaurants`,
    },
    zh: {
      title: '早茶店/粤菜馆',
      description: '告别传统的点餐、结账方式，拥抱餐饮科技降本增效',
    },
  },
  everythingNeedInOnePOSSystem: {
    en: {
      title: 'Recommended Products for Cantonese Restaurants',
    },
    zh: {
      title: '推荐使用的POS产品',
    },
  },
  usingServiceAdvantage: {
    ...usingServiceAdvantage,
  },
  frequentlyAskedQuestions: {
    ...frequentlyAskedQuestions,
  },
};

export default SectionContent;
